import { render, staticRenderFns } from "./CategoryProducts.vue?vue&type=template&id=5e657f90&"
import script from "./CategoryProducts.vue?vue&type=script&lang=js&"
export * from "./CategoryProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports